import { render, staticRenderFns } from "./PredictionsTable.vue?vue&type=template&id=2bc6c89a&scoped=true&"
import script from "./PredictionsTable.vue?vue&type=script&lang=js&"
export * from "./PredictionsTable.vue?vue&type=script&lang=js&"
import style0 from "./PredictionsTable.vue?vue&type=style&index=0&id=2bc6c89a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc6c89a",
  null
  
)

export default component.exports